import { useUserContext } from '../components/Providers/UserContext';

function Unauthorized() {
  const { logout } = useUserContext();

  return (
    <div
      style={{
        maxWidth: 600,
        margin: '100px auto',
        textAlign: 'center',
        padding: 20,
      }}
    >
      <h2>Oops! You do not have permission to access Tutoring Admin.</h2>
      <p style={{ marginTop: 16, fontSize: 14, fontWeight: 600 }}>
        Please log in with an admin account to continue.
      </p>
      <button
        onClick={logout}
        style={{
          marginTop: 24,
          padding: '10px 24px',
          fontSize: 14,
          cursor: 'pointer',
          backgroundColor: '#1976d2',
          color: '#fff',
          border: 'none',
          borderRadius: 4,
        }}
      >
        Back to Login
      </button>
    </div>
  );
}

export default Unauthorized;
